import React from 'react';
import PropTypes from 'prop-types';
import { ContentPackageGridTemplate } from './shared/ContentPackageGridTemplate';

export const ContentPackageTemplate5a = ({
  data,
  content,
  isAboveTheFold = false
}) => {
  return (
    <ContentPackageGridTemplate
      gridConfig={{
        lead: true,
        medium: [1, 2],
        small: [3, 4, 'content_package_right'],
        bottom: null
      }}
      data={data}
      content={content}
      isAboveTheFold={isAboveTheFold}
    />
  );
};

ContentPackageTemplate5a.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  content: PropTypes.objectOf(PropTypes.any).isRequired,
  isAboveTheFold: PropTypes.bool
};
